export default "__VITE_ASSET__BuZ1QRbj__"